import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
const THROTTLE_TIMEOUT = 100;
const APPEND_STYLES_TIMEOUT = 20;
class ContainerSize extends React.Component {
    componentDidMount() {
        window.addEventListener('resize', this.updateSize);
        this.updateSize();
        this.mounted = true;
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSize);
        this.mounted = false;
    }
    render() {
        const { className, children } = this.props;
        const { width, height } = this.state;
        // this is to fixate container size to ceil'ed values
        const style = width && height ? {
            width,
            height,
            // padding in such cases is used to set flexible ratio
            // e.g. width 100%, height via padding-top|bottom: calc(100% * 9/6) so that it's relative to width
            // once we fixate the dims, it becomes extraneous
            padding: 0
        } : {};
        return /*#__PURE__*/ React.createElement("div", {
            style: style,
            ref: this.saveContainerRef,
            className: className
        }, children({
            width,
            height
        }));
    }
    getContainerSize() {
        return {
            width: Math.ceil(get(this.containerRef, 'clientWidth', 0)),
            height: Math.ceil(get(this.containerRef, 'clientHeight', 0))
        };
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            width: undefined,
            height: undefined
        });
        _define_property(this, "containerRef", void 0);
        _define_property(this, "mounted", void 0);
        _define_property(this, "saveContainerRef", (ref)=>{
            this.containerRef = ref;
        });
        _define_property(this, "updateSize", throttle(()=>// wait for new stiles present by element queries
            setTimeout(()=>requestAnimationFrame(()=>{
                    const size = this.getContainerSize();
                    if (size.width === this.state.width && size.height === this.state.height) {
                        return;
                    }
                    this.mounted && this.setState(size);
                }), APPEND_STYLES_TIMEOUT), THROTTLE_TIMEOUT, {
            leading: false
        }));
    }
}
export { ContainerSize as default };
